import { gql } from 'apollo-angular';

const GET_RFP_PARTICIPANT_DOWNLOAD = gql`
  query GetRfpParticipantDownload($rfpId: Long) {
    rfpParticipantDownload(rfpId: $rfpId) {
      url
    }
  }
`;

export default GET_RFP_PARTICIPANT_DOWNLOAD;
